import React from 'react'
import { ConfirmationAction } from './confirmation-action'
import { RoleSwitch } from '../RoleSwitch'
import type { ConfirmationRoleActionProps } from '../../types/confirmationRoleAction'

export function ConfirmationRoleAction({
  isActionValid,
  role,
  requiredRole,
  renderDialog,
  icon,
  iconTooltipMessage,
  iconTooltipPlacement,
  iconMetadata,
  pendoId,
  hideTooltip,
  disabledTooltipMessage,
  showDisabled,
  testId,
  ...rest
}: ConfirmationRoleActionProps) {
  return (
    <>
      {isActionValid && (
        <RoleSwitch
          role={role}
          requiredRole={requiredRole}
          renderAllowed={() => {
            return (
              <ConfirmationAction
                {...rest}
                icon={icon}
                hideTooltip={hideTooltip}
                iconTooltipMessage={iconTooltipMessage}
                iconTooltipPlacement={iconTooltipPlacement}
                renderDialog={renderDialog}
                iconMetadata={iconMetadata}
                pendoId={pendoId}
                testId={testId}
              />
            )
          }}
          renderDenied={
            showDisabled
              ? () => (
                  <ConfirmationAction
                    {...rest}
                    icon={icon}
                    hideTooltip={hideTooltip}
                    iconTooltipMessage={disabledTooltipMessage || iconTooltipMessage}
                    iconTooltipPlacement={iconTooltipPlacement}
                    renderDialog={renderDialog}
                    iconMetadata={iconMetadata}
                    pendoId={pendoId}
                    isDisabled={true}
                    testId={testId}
                  />
                )
              : undefined
          }
        />
      )}
    </>
  )
}
